import React from 'react';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import 'utils/components/FiltersModal/comparison/TimeControl.scss';

interface TimeControlProps {
    hours: string;
    minutes: string;
    onChange: (value: string[]) => void;
    onInputEnter: () => void;
}

export default function TimeControl(props: TimeControlProps) {
    const { hours, minutes, onChange, onInputEnter } = props;
    return (
        <div className="TimeControl">
            <TextInput
                value={hours}
                onChange={onHourChange}
                placeholder={'HH'}
            />
            <TextInput
                value={minutes}
                onChange={onMinuteChange}
                onEnter={onInputEnter}
                placeholder={'MM'}
            />
        </div>
    );

    function onHourChange(hours: string) {
        onChange([hours, minutes]);
    }

    function onMinuteChange(minutes: string) {
        onChange([hours, minutes]);
    }
}
